import type { ReactElement } from 'react';
import { CardGlyph } from '../ui/CardGlyph.js';
import { DECK_GLYPH_SIZE } from '../ui/kit/tokens.js';

export interface DeckGlyphStripProps {
  cardIds: readonly string[];
  /** Pixel size passed through to each CardGlyph. */
  size?: number;
  /** How many distinct card arts to preview. */
  count?: number;
}

/** Compact art preview: the first few distinct cards rendered as code-native glyphs. */
export function DeckGlyphStrip({
  cardIds,
  size = DECK_GLYPH_SIZE,
  count = 3,
}: DeckGlyphStripProps): ReactElement | null {
  const unique = [...new Set(cardIds)].slice(0, count);
  if (unique.length === 0) return null;
  return (
    <div className="deck-glyph-strip" aria-hidden="true">
      {unique.map((cardId) => (
        <span className="deck-glyph-strip-item" key={cardId}>
          <CardGlyph defId={cardId} size={size} />
        </span>
      ))}
    </div>
  );
}
